import { GrowthBook } from '@growthbook/growthbook'
import { GrowthbookKey } from 'root-constants'

// An experiment can either be its own feature flag or a rule inside another
// feature (e.g. country PR tests live in the `currency` feature)
const findExperimentFeatureKey = (
  growthbook: GrowthBook,
  experimentKey: string,
): string | null => {
  const features = growthbook.getFeatures()

  if (features[experimentKey]) return experimentKey

  const hostFeature = Object.entries(features).find(([, definition]) =>
    definition.rules?.some((rule) => rule.key === experimentKey),
  )

  return hostFeature?.[0] || null
}

export const getGrowthbookVariantData = ({
  growthbook,
  growthbookKey,
}: {
  growthbook: GrowthBook | null
  growthbookKey?: GrowthbookKey | GrowthbookKey[]
}): Record<string, string> | string => {
  if (!growthbook || !growthbookKey) {
    return {}
  }

  const getValue = (key: GrowthbookKey) => {
    const featureKey = findExperimentFeatureKey(growthbook, key)

    if (!featureKey) return ''

    const {
      source,
      value,
      experiment,
      experimentResult,
    } = growthbook.evalFeature(featureKey)

    if (source === 'experiment' && experiment?.key === key) {
      return experimentResult?.inExperiment
        ? experimentResult.name || String(value ?? '')
        : ''
    }

    return featureKey === key && value != null ? String(value) : ''
  }

  if (Array.isArray(growthbookKey)) {
    const growthbookValues: Record<string, string> = {}

    growthbookKey.forEach((key) => {
      growthbookValues[key] = getValue(key)
    })

    return growthbookValues
  }

  return getValue(growthbookKey)
}
